module.exports = __webpack_public_path__ + "r-v3/img/emoti-tease-ya.4ec602fd.svg";